import { render, staticRenderFns } from "./OAuthCallback.vue?vue&type=template&id=73a5509e&scoped=true&"
import script from "./OAuthCallback.vue?vue&type=script&lang=js&"
export * from "./OAuthCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a5509e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VFlex})
